import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { childmap, createNlsMiddleware, keymap, lccstate, userstate } from '@holmescorp/lcc-state';
import { ProgressViz } from './progress-viz';
import css from '../css/progress-viz.m.css';
const nls = createNlsMiddleware('ditabook');
const factory = create({ lccstate, userstate, nls, theme });
export const AssessProgressViz = factory(({ middleware: { lccstate, userstate, nls, theme } }) => {
    const { messages: { assess_progress_threshold_low_label = '[ditabook] assess_progress_threshold_low_label', assess_progress_threshold_mid_label = '[ditabook] assess_progress_threshold_mid_label', assess_progress_threshold_high_label = '[ditabook] assess_progress_threshold_high_label', assess_topic_label = 'TOPIC', assess_section_label = 'SECTION', assess_legend = '[ditabook] assess_legend' } } = nls();
    const themeCss = theme.classes(css);
    const { get, path } = userstate;
    const assessment = get(path('assessment'));
    const roots = lccstate.get(lccstate.path('ditaroots'));
    const legend = v('div', { classes: [themeCss.legend] }, [
        v('span', {}, [assess_legend]),
        v('i', { classes: ['fas fa-check-circle', themeCss.proficient] }),
        v('span', {}, [assess_progress_threshold_high_label]),
        v('i', { classes: ['fas fa-exclamation-circle', themeCss.improvement] }),
        v('span', {}, [assess_progress_threshold_mid_label]),
        v('i', { classes: ['fas fa-exclamation-triangle', themeCss.inexperienced] }),
        v('span', {}, [assess_progress_threshold_low_label])
    ]);
    const topicResults = (root) => {
        const tsets = childmap.get(root) || [];
        return tsets
            .filter((ts) => assessment[ts] != null)
            .map((ts) => {
            const percentBase = assessment[ts].data.percent;
            const percent = percentBase > 1.0 ? percentBase / 100.0 : percentBase;
            const title = keymap.get(ts).title;
            const xqa = `topicset-viz ${ts}`;
            return w(ProgressViz, { xqa, title, percent, topic: ts });
        });
    };
    const kids = roots.map((root) => {
        const title = keymap.get(root)?.title || root;
        const tsResults = topicResults(root);
        if (!tsResults || tsResults.length === 0) {
            return null;
        }
        return v('div', { classes: [themeCss.domain, 'vizDomain'] }, [
            v('div', { classes: themeCss.topicHeader }, [
                v('div', { classes: themeCss.header }, [
                    v('div', { classes: themeCss.topic }, [assess_topic_label.toUpperCase()]),
                    v('div', { classes: [themeCss.topicTitle], role: 'heading', ...formatAriaProperties({ level: '2' }) }, [title])
                ])
            ]),
            v('div', { classes: themeCss.topicSection }, [
                v('div', { classes: themeCss.section }, [assess_section_label.toUpperCase()]),
                v('div', { classes: themeCss.sections }, [...topicResults(root)])
            ])
        ]);
    });
    return v('div', { key: 'root', xqa: `viz` }, [
        legend,
        v('div', { key: `scores`, role: 'list', xqa: `viz pre-test`, classes: [themeCss.root] }, kids)
    ]);
});
